import React from 'react';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const CommonSnackbar = ({ message, status, open, handleClose,time }) => {
  return (
    <div>
      <Snackbar open={open} autoHideDuration={time || 2000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={status}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CommonSnackbar;
